export const itIT = {
    price: 'Prezzo',
    apply: 'Applica',
    filterFor: 'Filtra per',
    default: 'Predefinito',
    alphabetic: 'Alfabetico',
    newest: 'Ultimi arrivi',
    popularity: 'Popolarità',
    priceHighToLow: 'Prezzo in ordine decrescente',
    priceLowToHigh: 'Prezzo in ordine crescente',
    showMore: 'Mostra successivi',
    showPrev: 'Mostra precedenti',
    noProductsFound: 'Nessun prodotto trovato',
    from: 'da',
    outOfStock: 'Non disponibile',
    addToCart: 'Aggiungi al carrello',
    addProductToCart: 'Aggiungi {0} al carrello',
    showProduct: 'Scopri di più',
};
export default itIT;
